import { BLE_PERIPHERAL_BATTERY_STATUS } from './constants'

export type BatteryStatus = {
  key: typeof BLE_PERIPHERAL_BATTERY_STATUS[keyof typeof BLE_PERIPHERAL_BATTERY_STATUS],
  value: number | string,
  icon: string,
  color: string,
  backgroundColor: string
}

/**
 * Bluetooth Battery Status Collection
 */
export default [
  {
    key: BLE_PERIPHERAL_BATTERY_STATUS.EMPTY,
    value: 0,
    icon: 'battery-empty',
    color: 'error.700',
    backgroundColor: 'error.50',
  },
  {
    key: BLE_PERIPHERAL_BATTERY_STATUS.LOW,
    value: 10,
    icon: 'battery-low',
    color: 'warning.700',
    backgroundColor: 'warning.50',
  },
  {
    key: BLE_PERIPHERAL_BATTERY_STATUS.MID,
    value: 50,
    icon: 'battery-mid',
    color: 'success.700',
    backgroundColor: 'success.50',
  },
  {
    key: BLE_PERIPHERAL_BATTERY_STATUS.FULL,
    value: 80,
    icon: 'battery-full',
    color: 'success.700',
    backgroundColor: 'success.50',
  },
] satisfies BatteryStatus[]
